import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { type FC, Fragment, type PropsWithChildren, useEffect, useState } from 'react';

import PoweredByNoodle from '@/components/PoweredByNoodle';
import Spacer from '@/components/Spacer';
import { isInPopoverWidget } from '@/helpers/helper';

const BaseLayout: FC<PropsWithChildren> = ({ children }) => {
  const router = useRouter();
  const [showPowered, setShowPowered] = useState(false);
  const isFormRequestPage = router.pathname.includes('/form-requests/');

  useEffect(() => {
    setShowPowered(!isInPopoverWidget());
  }, []);
  return (
    <Fragment>
      <Head>
        <link rel='icon' href='/favicon-32x32.png' />
      </Head>
      {children}
      {showPowered && !isFormRequestPage ? <PoweredByNoodle style={{ margin: '2rem 0' }} /> : <Spacer size={80} />}
    </Fragment>
  );
};

export default BaseLayout;
